/**
 *
 * @param die
 */
export function getCount(die) {
    return die.diceCount;
}
/**
 *
 * @param die
 */
export function getMultiplier(die) {
    return die.diceMultiplier;
}
/**
 *
 * @param die
 */
export function getString(die) {
    return die.diceString;
}
/**
 *
 * @param die
 */
export function getValue(die) {
    return die.diceValue;
}
/**
 *
 * @param die
 */
export function getFixedValue(die) {
    return die.fixedValue;
}
